<template>
<div class="quantity-selector-wrapper" :data-quantity = "this.quantity">
    <button @click="decreaseQuantity" class="quantity-selector-wrapper__button"><img src="../../../../../assets/button-minus.svg"></button>
    {{ this.quantity }}
    <button @click="increaseQuantity" class="quantity-selector-wrapper__button"><img src="../../../../../assets/button-plus.svg"></button>
</div>
</template>

<script>
import { ref } from 'vue/dist/vue.esm-bundler.js'
export default {
    name: 'QuantitySelector',
    setup() {
        let quantity = ref(1)
        return {
            quantity
        }
    },
    props: {
        elemId: Number,
        elemPrice: String,
        elemOriginalPrice: String
    },
    emits: [
        'itemQuantityUpdate'
    ],
    methods: {
        increaseQuantity() {
            this.quantity +=1;
            this.$emit('itemQuantityUpdate', {quantity: this.quantity, id: this.elemId });
            this.calculatePrice();
        },
        decreaseQuantity() {

            if (this.quantity > 1) {
                this.quantity -=1;
                this.$emit('itemQuantityUpdate', {quantity: this.quantity, id: this.elemId });
                this.calculatePrice();
            }
        },
        calculatePrice() {

            let price = this.elemPrice * this.quantity;
            
            //format money
            price = (price/100.0).toFixed(2);
            var parts   = price.split('.'),
            integers = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + "."),
            decimals   = parts[1] ? ("," + parts[1]) : '';

            let origPrice = this.elemOriginalPrice * this.quantity;
            
            //format money
            origPrice = (origPrice/100.0).toFixed(2);
            var origParts   = origPrice.split('.'),
            origIntegers = origParts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + "."),
            origDecimals   = origParts[1] ? ("," + origParts[1]) : '';


            if(document.querySelector(`.filter-item__select[data-variant-id="${this.elemId}"] .filter-item__total .currentPrice`)){
                document.querySelector(`.filter-item__select[data-variant-id="${this.elemId}"] .filter-item__total .currentPrice`).innerHTML = integers + " kr";
                document.querySelector(`.filter-item__select[data-variant-id="${this.elemId}"] .filter-item__total .basePrice`).innerHTML = origIntegers  + " kr";
            }else {
                document.querySelector(`.filter-item__select[data-variant-id="${this.elemId}"] .filter-item__total`).innerHTML = integers + " kr";
            }
        }
    }
}
</script>